import apiPaths from '../../helpers/apiPaths';
import api from '../DashBoard';
import { status200, status201 } from './status.utils';
import { handleResponse } from './response.utils';

export default {
  getSummaries: () => handleResponse('getSummaries', api.get(apiPaths.creditsSummaries, status200)),

  addCredits: creditInfo =>
    api.post(apiPaths.credits, creditInfo, status201).then(response => {
      if (!response.data.success) {
        throw new Error(response.data.error_message);
      }
      return response.data;
    })
};
